import Vue from 'vue'
const DEVICES = ['phone', 'tablet', 'desktop']
export default {
  namespaced: true,
  mutations: {
    addToArray(state, payload) {
      if (! payload.device) {
        payload.value.forEach(payloadProperty => {
          let array = this.getters['actionsModule/appState'](payload.module, payload.element, payload.parentModule)[payload.array]
          let propertyIndex = array.findIndex(arrayProperty => {
            if (Array.isArray(arrayProperty)) {
              return false
            }
            if (typeof arrayProperty != 'object') {
              return false
            }
            if (! Object.prototype.hasOwnProperty.call(arrayProperty, 'property')) {
              return false
            }
            return arrayProperty.property == payloadProperty.property
          })
          if (propertyIndex < 0) {
            array.push(payloadProperty)
            return
          }
          Vue.set(array, propertyIndex, payloadProperty)
        })
        return
      }
      if (payload.device == 'desktop') {
        payload.value.forEach(payloadClass => {
          DEVICES.forEach(device => {
            let deviceClasses = this.getters['actionsModule/appState'](payload.module, payload.element, payload.parentModule)[payload.array][device]
            let propertyIndex = deviceClasses.findIndex(deviceClass => deviceClass.property == payloadClass.property)
            if (propertyIndex < 0) {
                deviceClasses.push(payloadClass)
                return
            }
            if (deviceClasses[propertyIndex].touched && device != 'desktop') {
                return
            }
            Vue.set(deviceClasses, propertyIndex, payloadClass)
          })
        })
        return
      }
      payload.value.map(value => new Object({...value, touched: true})).forEach(payloadClass => {
        let deviceClasses = this.getters['actionsModule/appState'](payload.module, payload.element, payload.parentModule)[payload.array][payload.device]
        let propertyIndex = deviceClasses.findIndex(deviceClass => deviceClass.property == payloadClass.property)
        if (propertyIndex < 0) {
            deviceClasses.push(payloadClass)
            return
        }
        Vue.set(deviceClasses, propertyIndex, payloadClass)
      })
    },

    removeFromArray(state, payload) {
      if (! payload.device) {
        let array = this.getters['actionsModule/appState'](payload.module, payload.element, payload.parentModule)[payload.array]
          .filter(elementClass => ! payload.value.find(payloadClass => payloadClass == elementClass))
        return this.getters['actionsModule/appState'](payload.module, payload.element, payload.parentModule)[payload.array] = array
      }

      if (payload.device === 'desktop') {
        DEVICES.forEach(device => {
          let deviceClasses = this.getters['actionsModule/appState'](payload.module, payload.element, payload.parentModule)[payload.array][device]
          let classes = deviceClasses.filter(deviceClass => {
            return ! payload.value.find(payloadClass => payloadClass.property == deviceClass.property && ! deviceClass.touched)
          })
          Vue.set(this.getters['actionsModule/appState'](payload.module, payload.element, payload.parentModule)[payload.array], device, classes)
        })
        return
      }

      let deviceClasses = this.getters['actionsModule/appState'](payload.module, payload.element, payload.parentModule)[payload.array][payload.device]
      let classes = deviceClasses.filter(deviceClass => ! payload.value.find(payloadClass => payloadClass.property == deviceClass.property))
      Vue.set(this.getters['actionsModule/appState'](payload.module, payload.element, payload.parentModule)[payload.array], payload.device, classes)
    },

    addToObject(state, payload) {
      let element = this.getters['actionsModule/appState'](payload.module, payload.element, payload.parentModule)
      let object = this.getters['actionsModule/appState'](payload.module, payload.element, payload.parentModule)
      if (payload.object != 'base') {
        if (payload.device) {
          element = element[payload.object]
          object = object[payload.object][payload.device]
          element[payload.device] = {...object, ...payload.value}
          return
        }
        object = object[payload.object]

        if (payload.value === null) {
          return element[payload.object] = null
        }
        
        return element[payload.object] = {...object, ...payload.value}
      }

      if (payload.module == 'pageModule') {
        this.state.pageModule.page = {...object, ...payload.value}
      }

      if (payload.module == 'sectionModule') {
        this.state.pageModule.page.sections.splice(payload.element.section, 1, {...object, ...payload.value})
      }
      if (payload.module == 'rowModule') {
        this.state.pageModule.page.sections[payload.element.section]
          .rows.splice(payload.element.row, 1, {...object, ...payload.value})
      }
      if (payload.module == 'columnModule') {
        this.state.pageModule.page.sections[payload.element.section]
          .rows[payload.element.row]
          .columns.splice(payload.element.column, 1, {...object, ...payload.value})
      }
      if (payload.module == 'componentModule') {
        if (payload.element.pageComponent !== null && payload.element.pageComponent !== undefined) {
          return this.state.pageModule.page.components.splice(payload.element.component, 1, {...object, ...payload.value})
        }
        this.state.pageModule.page.sections[payload.element.section]
          .rows[payload.element.row]
          .columns[payload.element.column]
          .components.splice(payload.element.component, 1, {...object, ...payload.value})
      }
      if (payload.module == 'componentSectionModule') {
        if (payload.element.pageComponent !== null && payload.element.pageComponent !== undefined) {
          return this.state.pageModule.page.components[payload.element.pageComponent]
            .sections.splice(payload.element.componentSection, 1, {...object, ...payload.value})
        }
        this.state.pageModule.page.sections[payload.element.section]
          .rows[payload.element.row]
          .columns[payload.element.column]
          .components[payload.element.component]
          .sections.splice(payload.element.componentSection, 1, {...object, ...payload.value})
      }
      if (payload.module == 'componentRowModule') {
        if (payload.element.pageComponent !== null && payload.element.pageComponent !== undefined) {
          return this.state.pageModule.page.components[payload.element.pageComponent]
            .sections[payload.element.componentSection]
            .rows.splice(payload.element.componentRow, 1, {...object, ...payload.value})
        }
        this.state.pageModule.page.sections[payload.element.section]
          .rows[payload.element.row]
          .columns[payload.element.column]
          .components[payload.element.component]
          .sections[payload.element.componentSection]
          .rows.splice(payload.element.componentRow, 1, {...object, ...payload.value})
      }
      if (payload.module == 'componentColumnModule') {
        if (payload.element.pageComponent !== null && payload.element.pageComponent !== undefined) {
          return this.state.pageModule.page.components[payload.element.pageComponent]
            .sections[payload.element.componentSection]
            .rows[payload.element.componentRow]
            .columns.splice(payload.element.componentColumn, 1, {...object, ...payload.value})
        }
        this.state.pageModule.page.sections[payload.section]
          .rows[payload.element.row]
          .columns[payload.element.column]
          .components[payload.element.component]
          .sections[payload.element.componentSection]
          .rows[payload.element.componentRow]
          .columns.splice(payload.element.componentColumn, 1, {...object, ...payload.value})
      }
      if (payload.module == 'componentComponentModule') {
        if (payload.element.pageComponent !== null && payload.element.pageComponent !== undefined) {
          return this.state.pageModule.page.components[payload.element.pageComponent]
            .sections[payload.element.componentSection]
            .rows[payload.element.componentRow]
            .columns[payload.element.componentColumn]
            .components.splice(payload.element.componentComponent, 1, {...object, ...payload.value})
        }
        this.state.pageModule.page.sections[payload.section]
          .rows[payload.element.row]
          .columns[payload.element.column]
          .components[payload.element.component]
          .sections[payload.element.componentSection]
          .rows[payload.element.componentRow]
          .columns[payload.element.componentColumn]
          .components.splice(payload.element.componentComponent, 1, {...object, ...payload.value})
      }
    },

    updateElementsOrder(state, payload) {
      if (payload.module == 'layoutRowModule') {
        let parentModule = payload.parentModule == 'topSectionModule' ? 'topSection' : 'bottomSection'
        this.state.layoutModule[parentModule].rows = payload.value
      }

      if (payload.module == 'layoutColumnModule') {
        let parentModule = payload.parentModule == 'topSectionModule' ? 'topSection' : 'bottomSection'
        this.state.layoutModule[parentModule].rows[payload.row].columns = payload.value
      }

      if (payload.module == 'layoutComponentModule') {
        let parentModule = payload.parentModule == 'topSectionModule' ? 'topSection' : 'bottomSection'
        this.state.layoutModule[parentModule].rows[payload.row].columns[payload.column].components = payload.value
      }

      if (payload.module == 'sectionModule') {
        this.state.pageModule.page.sections = payload.value
      }

      if (payload.module == 'rowModule') {
        this.state.pageModule.page.sections[payload.section].rows = payload.value
      }

      if (payload.module == 'columnModule') {
        this.state.pageModule.page.sections[payload.section].rows[payload.row].columns = payload.value
      }

      if (payload.module == 'componentModule') {
        this.state.pageModule.page.sections[payload.section].rows[payload.row].columns[payload.column].components = payload.value
      }

      if (payload.module == 'componentSectionModule') {
        if (payload.parentModule == 'topSectionModule') {
          return this.state.layoutModule['topSection']
            .rows[payload.row]
            .columns[payload.column]
            .components[payload.component]
            .sections = payload.value
        }
        if (payload.parentModule == 'bottomSectionModule') {
          return this.state.layoutModule['bottomSection']
            .rows[payload.row]
            .columns[payload.column]
            .components[payload.component]
            .sections = payload.value
        }
        if (payload.pageComponent !== null && payload.pageComponent !== undefined) {
          return this.state.pageModule.page
            .components[payload.pageComponent]
            .sections = payload.value
        }
        this.state.pageModule.page
          .sections[payload.section]
          .rows[payload.row]
          .columns[payload.column]
          .components[payload.component]
          .sections = payload.value
      }

      if (payload.module == 'componentRowModule') {
        if (payload.parentModule == 'layoutPageComponentModule') {
          return this.state.layoutModule.components[payload.layoutPageComponent]
            .sections[payload.componentSection]
            .rows = payload.value
        }
        if (payload.parentModule == 'topSectionModule') {
          return this.state.layoutModule['topSection']
            .rows[payload.row]
            .columns[payload.column]
            .components[payload.component]
            .sections[payload.componentSection]
            .rows = payload.value
        }
        if (payload.parentModule == 'bottomSectionModule') {
          return this.state.layoutModule['bottomSection']
            .rows[payload.row]
            .columns[payload.column]
            .components[payload.component]
            .sections[payload.componentSection]
            .rows = payload.value
        }
        if (payload.pageComponent !== null && payload.pageComponent !== undefined) {
          return this.state.pageModule.page
            .components[payload.pageComponent]
            .sections[payload.componentSection]
            .rows = payload.value
        }
        this.state.pageModule.page.sections[payload.section]
          .rows[payload.row]
          .columns[payload.column]
          .components[payload.component]
          .sections[payload.componentSection]
          .rows = payload.value
      }

      if (payload.module == 'componentColumnModule') {
        if (payload.parentModule == 'topSectionModule') {
          return this.state.layoutModule['topSection']
            .rows[payload.row]
            .columns[payload.column]
            .components[payload.component]
            .sections[payload.componentSection]
            .rows[payload.componentRow]
            .columns = payload.value
        }
        if (payload.parentModule == 'bottomSectionModule') {
          return this.state.layoutModule['bottomSection']
            .rows[payload.row]
            .columns[payload.column]
            .components[payload.component]
            .sections[payload.componentSection]
            .rows[payload.componentRow]
            .columns = payload.value
        }
        if (payload.parentModule == 'layoutPageComponentModule') {
          return this.state.layoutModule.components[payload.layoutPageComponent]
            .sections[payload.componentSection]
            .rows[payload.componentRow]
            .columns = payload.value
        }
        if (payload.pageComponent !== null && payload.pageComponent !== undefined) {
          return this.state.pageModule.page
            .components[payload.pageComponent]
            .sections[payload.componentSection]
            .rows[payload.componentRow]
            .columns = payload.value
        }
        this.state.pageModule.page
          .sections[payload.section]
          .rows[payload.row]
          .columns[payload.column]
          .components[payload.component]
          .sections[payload.componentSection]
          .rows[payload.componentRow]
          .columns = payload.value
      }

      if (payload.module == 'componentComponentModule') {
        if (payload.parentModule == 'topSectionModule') {
          return this.state.layoutModule['topSection']
            .rows[payload.row]
            .columns[payload.column]
            .components[payload.component]
            .sections[payload.componentSection]
            .rows[payload.componentRow]
            .columns[payload.componentColumn]
            .components = payload.value
        }
        if (payload.parentModule == 'bottomSectionModule') {
          return this.state.layoutModule['bottomSection']
            .rows[payload.row]
            .columns[payload.column]
            .components[payload.component]
            .sections[payload.componentSection]
            .rows[payload.componentRow]
            .columns[payload.componentColumn]
            .components = payload.value
        }
        if (payload.parentModule == 'layoutPageComponentModule') {
          return this.state.layoutModule.components[payload.layoutPageComponent]
            .sections[payload.componentSection]
            .rows[payload.componentRow]
            .columns[payload.componentColumn]
            .components = payload.value
        }
        if (payload.pageComponent !== null && payload.pageComponent !== undefined) {
          return this.state.pageModule.page
            .components[payload.pageComponent]
            .sections[payload.componentSection]
            .rows[payload.componentRow]
            .columns[payload.componentColumn]
            .components = payload.value
        }
        this.state.pageModule.page.sections[payload.section]
          .rows[payload.row]
          .columns[payload.column]
          .components[payload.component]
          .sections[payload.componentSection]
          .rows[payload.componentRow]
          .columns[payload.componentColumn]
          .components = payload.value
      }
    },
  },

  getters: {
    appState: (state, getters, rootState, rootGetters) => {
      return (module, element, parentModule) => {
        if (module == 'pageModule') {
          return rootState.pageModule.page
        }
        if (module == 'layoutModule') {
          return rootState.layoutModule
        }
        return rootGetters[`${module}/elements`](element, parentModule)
      }
    },
    appDevice: (state, getters, rootState, rootGetters) => rootGetters['pageModule/device'],
  }
}
